import React from 'react';
import { History } from "history";
import { Row, Col, Card, CampoEstatico, TipoCampoEstatico, Alerta, TipoAlerta, Box } from '@intechprev/componentes-web';
import { SimuladorRendaMensalService, PlanoService, FuncionarioService, FichaFinanceiraService } from '../../services';
import { SimuladorRendaMensalDatas, PlanoVinculadoEntidade, FuncionarioDados } from '../../entidades';
import { MasterPage, NumFuncionalidade } from '../MasterPage';
import { Link } from 'react-router-dom';
import { reCAPTCHA } from '../../helpers';
import { LoadingComponent } from '../../components';

interface Props {
  match?: any;
  history?: History;
};

interface State {
  dataAporte: string;
  valorAporte: number;
  dataInicioRMV: string;
  taxaResgate: number;
  taxaContribuicao: number;
  rentabilidadeAnual: string;
  rentabilidadeMensal: number;
  SaldoAcomulado: number;
  SaldoProjetado: number;
  SaqueVista: number;
  ContribuicaoMensal: number;
  Datas: SimuladorRendaMensalDatas;
  DataReferencia: string;
  FatorAtuarialInterpolado: number;

  Ativo: boolean;
  Funcionario: FuncionarioDados;
  Erro: string;
  Loading: boolean;
};

export class SimuladorRendaMensalResultado extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("simulador_renda_mensal_resultado");

  private page = React.createRef<MasterPage>();

  constructor(props: Props) {
    super(props);

    this.state = {
      dataAporte: props.match.params.dataAporte || "0",
      valorAporte: props.match.params.valorAporte || 0,
      dataInicioRMV: props.match.params.dataInicioRMV || "",
      taxaResgate: props.match.params.taxaResgate || 0,
      taxaContribuicao: props.match.params.taxaContribuicao || 0,
      rentabilidadeAnual: props.match.params.rentabilidadeAnual || 0,
      rentabilidadeMensal: 0,
      SaldoAcomulado: 0,
      SaldoProjetado: 0,
      SaqueVista: 0,
      ContribuicaoMensal: 0,
      FatorAtuarialInterpolado: 0,
      Datas: new SimuladorRendaMensalDatas(),
      DataReferencia: "",

      Ativo: false,
      Funcionario: new FuncionarioDados(),
      Erro: "",
      Loading: true
    };
  }

  componentDidMount = async () => {
    try {
      const plano = await PlanoService.Buscar();
      const Ativo = this.CondicaoAtivo(plano);
      const Funcionario = await FuncionarioService.Buscar();

      const expoente = (1 / 12);

      const rentabilidadeMensal = (Math.pow(1 + (Number(this.state.rentabilidadeAnual) / 100), expoente) - 1) * 100;

      const UltimaContribuicao = await FichaFinanceiraService.BuscarUltimaExibicaoPorPlano("0002");

      const DataReferencia = (UltimaContribuicao.cotas[0].DT_IND);

      const Datas = await SimuladorRendaMensalService.BuscarDatasResultado(this.state.dataInicioRMV, DataReferencia.replace(/\//gm, "."), this.state.dataAporte);

      const FatorAtuarialInterpolado = await SimuladorRendaMensalService.BuscarFatorAtuarialInterpoladoPorData(this.state.dataInicioRMV);

      const ValorSalario = UltimaContribuicao.salario.length > 0 ?
        UltimaContribuicao.salario[0].SRC : 0;

      const ContribuicaoMensal = (ValorSalario * this.state.taxaContribuicao / 100) * 2;

      const ContribuicaoMensal13 = ContribuicaoMensal / 12;

      const SaldoAcomulado =
        ((UltimaContribuicao.saldosSem[0].QTD_COTA_RP_EMPRESA || 0) +
          (UltimaContribuicao.saldosSem[0].QTD_COTA_RP_PARTICIPANTE || 0) +
          (UltimaContribuicao.saldosCom[0].QTD_COTA_RP_EMPRESA || 0) +
          (UltimaContribuicao.saldosCom[0].QTD_COTA_RP_PARTICIPANTE || 0)
        ) * UltimaContribuicao.cotas[0].VALOR_IND;

      let SaldoProjetado = SaldoAcomulado;

      for (let i = 1; i < Datas.MES_RMV + 1; i++) {
        const ValorAporte = (i === Datas.MES_APORTE) ? this.state.valorAporte : 0;
        SaldoProjetado = (SaldoProjetado + (SaldoProjetado * rentabilidadeMensal / 100)) + ContribuicaoMensal + ContribuicaoMensal13 + Number(ValorAporte);
      }

      const SaqueVista = SaldoProjetado * (this.state.taxaResgate / 100);

      this.setState({
        rentabilidadeMensal,
        SaldoAcomulado,
        SaldoProjetado,
        SaqueVista,
        ContribuicaoMensal,
        FatorAtuarialInterpolado,
        Datas,
        DataReferencia,
        Ativo,
        Funcionario
      });
    }
    catch (e) {
      const err: any = e;
      this.setState({
        Erro: err.response ? err.response.data : err
      });
    }
    finally {
      this.setState({ Loading: false });
    }
  }

  CondicaoAtivo = (plano: Array<PlanoVinculadoEntidade>) => {
    return plano.some(p =>
      p.CD_PLANO === "0002" &&
      (p.CD_CATEGORIA === "1" ||
        p.CD_CATEGORIA === "3" ||
        p.CD_CATEGORIA === "6")
    );
  };

  renderAtivo = () => {
    if (this.state.Ativo) {
      return (
        <>
          <h4>{"Bem-Vindo ao Simulador de Renda Mensal Vitalícia (RMV)!"}</h4>

          <Box titulo={"Simulador RMV - Plano B"} subtitulo={`Olá, ${this.state.Funcionario.DadosPessoais.NOME_ENTID}! Os dados abaixo serão utilizados na simulação da sua RMV.`} label={`Posição de ${this.state.DataReferencia}`}>
            <Row>
              <Col>
                <Card titulo={"Idade na Adesão"}>
                  <span className={"text-info"}>
                    {this.state.Datas.IDADE_ADESAO}
                  </span>
                </Card>
              </Col>

              <Col>
                <Card titulo={"Idade no Início da RMV"}>
                  <span className={"text-info"}>
                    {this.state.Datas.IDADE_RMV}
                  </span>
                </Card>
              </Col>

              <Col>
                <Card titulo={"Saldo Projetado Acumulado"}>
                  <span className={"text-info"}>
                    <CampoEstatico
                      valor={this.state.SaldoProjetado}
                      tipo={TipoCampoEstatico.dinheiro}
                    />
                  </span>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card titulo={`Saque à vista de ${this.state.taxaResgate}% do Saldo Projetado Acumulado`}>
                  <span className={"text-info"}>
                    <CampoEstatico
                      valor={this.state.SaqueVista}
                      tipo={TipoCampoEstatico.dinheiro}
                    />
                  </span>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card titulo={"Renda Mensal Vitalícia (com o Resgate à Vista)"}>
                  <span className={"text-success"}>
                    <CampoEstatico
                      valor={(this.state.SaldoProjetado - this.state.SaqueVista) / (13 * this.state.FatorAtuarialInterpolado)}
                      tipo={TipoCampoEstatico.dinheiro}
                    />
                  </span>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card titulo={"Renda Mensal Vitalícia (sem o Resgate à Vista)"}>
                  <span className={"text-info"}>
                    <CampoEstatico
                      valor={(this.state.SaldoProjetado) / (13 * this.state.FatorAtuarialInterpolado)}
                      tipo={TipoCampoEstatico.dinheiro}
                    />
                  </span>
                </Card>
              </Col>
            </Row>

            <Box>
              <Alerta
                mensagem={
                  `- Valores monetários expressos em reais (R$).
                            <br/><br/>
                            - Bases técnicas: tábuas de mortalidade: AT-2000 (suav. 10%) (d10%) M&F, Taxa Atuarial de Juros de 3,79% e Rentabilidade Anual de ${this.state.rentabilidadeAnual}%;
                            <br/><br/>
                            - Os valores de simulação tem caráter apenas ilustrativo, não gera qualquer direito ao seu recebimento. o valor da renda dependerá do montante capitalizado resultante das contribuições efetivamente recolhidas e da rentabilidade real obtida durante o período de capitalização, bem como da característica etária do participante, na data da aposentadoria.
                            <br/><br/>
                            - Caso o valor inicial da renda inicial, apurada na data efetiva do primeiro pagamento do benefício, após o saque de 25%, seja igual ou inferior ao valor correspondente a 15% (quinze por cento) do valor correspondente ao teto máximo de contribuição para a Previdência Social, será facultado o saque, à vista, da totalidade do saldo acumulado nas contas Participante e Patrocinador, em seu nome.`
                }
                tipo={TipoAlerta.info}
              />
            </Box>

            <Link className={"btn btn-primary btn-block"} to={"/simuladorRendaMensal"}>{"Nova Simulação"}</Link>
          </Box>

        </>
      );
    }
    return (
      <Alerta
        tipo={this.state.Erro ? TipoAlerta.danger : TipoAlerta.info}
        mensagem={this.state.Erro || "Simulador de Renda Mensal Vitalícia disponível apenas para participantes ATIVOS do PLANO B."}
      />
    );
  }

  render() {
    return (
      <MasterPage Funcionalidade={NumFuncionalidade.SIMULADOR_RENDA_MENSAL} {...this.props} ref={this.page}>
        {this.state.Loading && <LoadingComponent />}

        {!this.state.Loading && this.renderAtivo()}
      </MasterPage>
    );
  }
}